module.exports = __webpack_public_path__ + "img/overcast clouds.644bdd1b.jpg";